import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/content';
const tints = ['#E6F2FB', '#FFF7E4', '#FDEAEC'];
function Stars({
  delay = 0
}: {
  delay?: number;
}) {
  const reduce = useReducedMotion();
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-226" data-mp="36z97ain8bpwa">
      {Array.from({
      length: 5
    }).map((_, i) => <motion.span key={i} animate={reduce ? undefined : {
      scale: [1, 1.18, 1]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      repeatDelay: 1.6,
      delay: delay + i * 0.1,
      ease: 'easeInOut'
    }} data-id="element-227" data-mp="31z37gf6t2x34" data-mpi={i}>
          <StarIcon className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-228" data-mp="v8wuwec8fset" />
        </motion.span>)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-11 sm:py-14" aria-labelledby="testimonials-title" data-id="element-229" data-mp="h5oq3c5zm87y">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-230" data-mp="m5b5ns9ag0jx">
        <Reveal data-id="element-231" data-mp="m2omswgy5yme">
          <h2 id="testimonials-title" className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-232" data-mp="780jnoz0rc9y">
            Lo que dicen <span className="text-sky" data-id="element-233" data-mp="zwfv61ixzcgj">las familias</span>
          </h2>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-234" data-mp="zyseai0frsv6">
          {testimonials.map((t, i) => <Reveal as="article" key={i} delay={i * 0.08} data-id="element-235" data-mp="q6wdgz6yton9" data-mpi={i}>
              <figure className="relative flex h-full flex-col rounded-3xl p-6 transition-transform duration-300 hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
            backgroundColor: tints[i % tints.length]
          }} data-id="element-236" data-mp="q6ctze1o2s74">
                <QuoteIcon className="absolute right-5 top-5 h-8 w-8 opacity-20" style={{
              color: t.accent
            }} aria-hidden="true" data-id="element-237" data-mp="1nnbmkxjhk5n9" />
                <Stars delay={i * 0.3} data-id="element-238" data-mp="1sjpbwv3gndeb" />
                <blockquote className="mt-4 flex-1 font-sans text-sm leading-relaxed text-ink" data-id="element-239" data-mp="1oh2kuwem5wi6">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3" data-id="element-240" data-mp="1jhyba4ns1wrb">
                  {t.avatar ? <img src={t.avatar} alt="" className="h-10 w-10 rounded-full object-cover" width={80} height={80} loading="lazy" decoding="async" data-id="element-241" data-mp="1el7utg828z5d" /> : <span className="flex h-10 w-10 items-center justify-center rounded-full font-display text-xs font-extrabold text-white" style={{
                backgroundColor: t.accent
              }} aria-hidden="true" data-id="element-242" data-mp="vswwlzocppdl">
                      {t.initials}
                    </span>}
                  <span data-id="element-243" data-mp="37htkqnfowybt">
                    <span className="block font-display text-sm font-extrabold text-navy" data-id="element-244" data-mp="3cek4plum8e2i">
                      {t.name}
                    </span>
                    {t.country && <span className="block font-sans text-xs text-muted" data-id="element-245" data-mp="2jqo9ymolww8d">{t.country}</span>}
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        {/* Editable social proof zone — fill in only with real data. */}
        <Reveal delay={0.1} data-id="element-246" data-mp="2xicjqjbdv8m6">
          <div className="mx-auto mt-7 max-w-2xl rounded-3xl bg-cream2 p-6 text-center" data-id="element-247" data-mp="2xim9c5sindrc">
            <p className="font-sans text-[11px] leading-relaxed text-muted/70" style={{
            fontWeight: "400"
          }} data-id="element-248" data-mp="20yvgys9jfb0n">
               ★★★★★ 4.9/5 · Más de 300 familias ya disfrutan las actividades · criarcon_imaginación + 10K de seguidores en instagram

            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}